import { render, staticRenderFns } from "./routeMap.vue?vue&type=template&id=3bb72bf4&scoped=true&"
import script from "./routeMap.vue?vue&type=script&lang=js&"
export * from "./routeMap.vue?vue&type=script&lang=js&"
import style0 from "./routeMap.vue?vue&type=style&index=0&id=3bb72bf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb72bf4",
  null
  
)

export default component.exports